// extracted by mini-css-extract-plugin
export default {"blue":"z1JDiDxCnQnHhRgnjt9O","container":"ASbbJhOVaKeVsJCRVlMi","controlContainer":"tC73yZes3sMWi2zoWowJ","buttonDropStyles":"AwzCTAb8cuthNdN9FRZp"};